import { AllResultTypes, constants, IDataGridColumnConfiguration, IDataGridValidator } from '@trackman/baseball-shared-components';
import { DataKey } from 'enums/DataKey';
import { IError } from 'interfaces/review/IReviewDataRow';
import { ReviewDataRow } from 'models/review/ReviewDataRow/ReviewDataRow';

export const playResultValidator: IDataGridValidator = {
  validate: (rows: ReviewDataRow[], columns: IDataGridColumnConfiguration[]) => {
    const columnObj = {} as { [key in DataKey]: IDataGridColumnConfiguration };

    for (const column of columns) {
      columnObj[column.dataKey as DataKey] = column;
    }

    const { firstBase, secondBase, thirdBase, playResult } = columnObj;

    if (!firstBase || !secondBase || !thirdBase || !playResult) {
      return rows.map(() => []);
    }

    return rows.map((r) => validateRow(r, firstBase, secondBase, thirdBase, playResult));
  },
};

const validateRow = (
  row: ReviewDataRow,
  firstBaseColumn: IDataGridColumnConfiguration,
  secondBaseColumn: IDataGridColumnConfiguration,
  thirdBaseColumn: IDataGridColumnConfiguration,
  playResultColumn: IDataGridColumnConfiguration
): IError[] => {
  const errors: IError[] = [];
  if (row.isWarmup || row.isDeleted) {
    return [];
  }

  const firstBase = row[firstBaseColumn.dataKey as keyof ReviewDataRow];
  const secondBase = row[secondBaseColumn.dataKey as keyof ReviewDataRow];
  const thirdBase = row[thirdBaseColumn.dataKey as keyof ReviewDataRow];
  const playResult = row[playResultColumn.dataKey as keyof ReviewDataRow];

  const noPlayersOnBases = (firstBase: any, secondBase: any, thirdBase: any): boolean => {
    return (
      (!firstBase || firstBase.id === constants.emptyGuid) &&
      (!secondBase || secondBase.id === constants.emptyGuid) &&
      (!thirdBase || thirdBase.id === constants.emptyGuid)
    );
  };

  if (playResult === AllResultTypes.StolenBase || playResult === AllResultTypes.CaughtStealing) {
    if (noPlayersOnBases(firstBase, secondBase, thirdBase)) {
      errors.push({
        dataKey: `${playResult}`,
        errorMessage: `Play result can't be ${playResult} because there's no players on bases`,
      });
    }
  }

  return errors;
};
